import { Box, Card, Paragraph } from '@zillow/constellation-10';
import { LeaseStatus } from '@zg-rentals/rental-manager-env';

import { FULLSTORY_EXCLUDE } from '../../../../constants/analytics';
import type { Lease } from '../../../../models';

type Props = {
  cancellationReason: string;
  lease: Lease;
};

export default function CancellationConfirmation({ cancellationReason, lease }: Props): JSX.Element {
  const isOfflineSigning = lease?.status === LeaseStatus.SENT_FOR_OFFLINE_SIGNING;

  return (
    <Box css={{ display: 'flex', flexDirection: 'column', gap: 'tight' }}>
      <Paragraph>
        {isOfflineSigning
          ? 'We notified your renters that signing has been canceled. When your lease is ready for signing, request signatures again from your leases dashboard.'
          : 'We notified your renters that the lease signing has been canceled. When your lease is ready for signing, request signatures again from your leases dashboard.'}
      </Paragraph>
      <Box css={{ display: 'flex', flexDirection: 'column', gap: 'tighter' }}>
        <Card tone="soft" elevated={false} outlined={false} className={FULLSTORY_EXCLUDE}>
          <Paragraph css={{ textStyle: 'body-sm-bold' }}>Your reason for canceling signing</Paragraph>
          <Paragraph css={{ textStyle: 'body-sm', fontStyle: 'italic' }}>“{cancellationReason}”</Paragraph>
        </Card>
        <Paragraph css={{ textStyle: 'body-xs' }}>This message was sent to all tenants</Paragraph>
      </Box>
    </Box>
  );
}
